// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Scenario{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;height:100%;min-height:100%;overflow:hidden;position:relative}", ""]);
// Exports
module.exports = exports;
